module.exports = __webpack_public_path__ + "img/spritz_ok.12868459.jpg";